var SessionEvents = {
  "TermsAcceptRequired": "TermsAcceptRequired",
  "PasswordReset": "PasswordReset",
  "FinalizeRegistration": "FinalizeRegistration",
  "Message": "Message"
};
export default SessionEvents;